import clsx from 'clsx';

interface GuidanceTextProps {
  text?: string | null;
  className?: string;
  placeholder?: string;
}

type Block = { type: 'list'; items: string[] } | { type: 'para'; text: string };

const isBullet = (line: string) => line.trimStart().startsWith('*');
const bulletContent = (line: string) => line.trimStart().slice(1).trim();

const GuidanceText = ({ text, className, placeholder = '—' }: GuidanceTextProps) => {
  if (!text || !text.trim()) {
    return <p className={clsx('text-sm text-gray-700 dark:text-gray-200', className)}>{placeholder}</p>;
  }

  const blocks: Block[] = [];
  for (const line of text.split('\n')) {
    if (isBullet(line)) {
      const last = blocks[blocks.length - 1];
      if (last && last.type === 'list') last.items.push(bulletContent(line));
      else blocks.push({ type: 'list', items: [bulletContent(line)] });
    } else if (line.trim()) {
      blocks.push({ type: 'para', text: line });
    }
  }

  return (
    <div className={clsx('space-y-2 text-sm text-gray-700 dark:text-gray-200', className)}>
      {blocks.map((block, i) =>
        block.type === 'list' ? (
          <ul key={i} className="list-disc space-y-1 pl-5">
            {block.items.map((item, j) => (
              <li key={j}>{item}</li>
            ))}
          </ul>
        ) : (
          <p key={i} className="whitespace-pre-wrap">
            {block.text}
          </p>
        )
      )}
    </div>
  );
};

export default GuidanceText;
